import * as _ from 'lodash';
import { EventTypeLabelPipe } from '../pipes/EventTypeLabelPipe';

export const EventTypeEnum = Object.freeze({
    REGISTER: 'REGISTER',
    DEPOSIT: 'DEPOSIT',
    WITHDRAWAL: 'WITHDRAWAL',
    BASIC_ID_GATHERED: 'BASIC_ID_GATHERED',
    BASIC_INFO_GATHERED: 'BASIC_INFO_GATHERED',
    PHOTOGRAPHIC_EVIDENCE_GATHERED: 'PHOTOGRAPHIC_EVIDENCE_GATHERED',
    PEP_CHECK_DONE: 'PEP_CHECK_DONE',
    SANCTION_CHECK_DONE: 'SANCTION_CHECK_DONE',
    EVIDENCE_OF_SOW_INCOME_OCCUPATION_DONE:
        'EVIDENCE_OF_SOW_INCOME_OCCUPATION_DONE',
    DUE_DILIGENCE_DONE: 'DUE_DILIGENCE_DONE',
    BET: 'BET',
    CHAT: 'CHAT',
    ASK_FOR_OFFERS: 'ASK_FOR_OFFERS'
});

export const makeEventTypeDropdownOptions = () =>
    _.map(EventTypeEnum, (value, key) => ({
        label: EventTypeLabelPipe(key),
        value
    }));
